/* eslint-disable react-hooks/exhaustive-deps */
import { DatePicker, Form } from "antd";

import React, { useEffect, useState } from "react";

import { getUserEstablishment } from "../../http-request/user";

const PageReportDatePicker = ({ request }) => {
  const [datesWithRecord, setdatesWithRecord] = useState([]);

  const loadDatesOfReports = async () => {
    const token = localStorage.getItem("token");
    let establishmentId = await getUserEstablishment(token);
    await request.getDatesOfReports(establishmentId, token).then((result) => {
      let _dates = [];
      result.forEach((_result) => _dates.push(_result.date));
      setdatesWithRecord(_dates);
    });
  };

  useEffect(() => {
    loadDatesOfReports();
  }, []);

  return (
    <>
      <Form.Item
        name={"date"}
        rules={[
          {
            required: true,
            message: "Please select a date!",
          },
        ]}
      >
        <DatePicker
          style={{ width: "100%" }}
          placement="bottomLeft"
          dateRender={(current) => {
            const style = {};
            if (datesWithRecord.includes(current.format("YYYY-MM-DD"))) {
              style.backgroundColor = "red";
              style.color = "#fff";
              style.borderRadius = "5%";
            }
            return (
              <div className="ant-picker-cell-inner" style={style}>
                {current.date()}
              </div>
            );
          }}
        />
      </Form.Item>
    </>
  );
};

export default PageReportDatePicker;
